import type { SVGProps } from 'react'

type IconProps = Omit<SVGProps<SVGSVGElement>, 'viewBox' | 'fill'>

// Decorative glyphs: the control they sit in carries the accessible name.
// Sized and coloured by the CSS of the control that holds them.

const Icon24 = (props: IconProps) => (
  <svg viewBox='0 0 24 24' fill='none' aria-hidden='true' {...props} />
)

const Icon16 = (props: IconProps) => (
  <svg viewBox='0 0 16 16' fill='none' aria-hidden='true' {...props} />
)

const stroke = (width: number) =>
  ({
    stroke: 'currentColor',
    strokeWidth: width,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  }) as const

export const ChevronRightIcon = (props: IconProps) => (
  <Icon24 {...props}>
    <path d='m9 6 6 6-6 6' {...stroke(1.75)} />
  </Icon24>
)

export const ArrowRightIcon = (props: IconProps) => (
  <Icon24 {...props}>
    <path d='M5 12h14m-6-6 6 6-6 6' {...stroke(1.75)} />
  </Icon24>
)

export const ArrowLeftIcon = (props: IconProps) => (
  <Icon24 {...props}>
    <path
      d='M2.689 12l8.78-8.78 1.061 1.06-5.262 5.263c-.63.63-.184 1.707.707 1.707H21v1.5H7.975c-.891 0-1.337 1.077-.707 1.707l5.262 5.263-1.06 1.06L2.688 12Z'
      fill='currentColor'
    />
  </Icon24>
)

export const CloseIcon = (props: IconProps) => (
  <Icon24 {...props}>
    <path d='M7 7l10 10M17 7 7 17' {...stroke(1.75)} />
  </Icon24>
)

export const InfoIcon = (props: IconProps) => (
  <Icon24 {...props}>
    <path
      d='M9.5 10.25H12.25V17.5M9 17.5h6.5'
      stroke='currentColor'
      strokeWidth='1.75'
    />
    <circle cx='12' cy='6.75' r='1.35' fill='currentColor' />
  </Icon24>
)

export const ChevronsUpDownIcon = (props: IconProps) => (
  <Icon16 {...props}>
    <path
      d='M8 1.83333L12.3333 6.13476L11.6296 6.83333L8.93932 4.16288C8.41943 3.64682 7.58057 3.64682 7.06068 4.16288L4.37042 6.83333L3.66667 6.13476L8 1.83333Z'
      fill='currentColor'
    />
    <path
      d='M8 14.1667L3.66667 9.86524L4.37042 9.16667L7.06068 11.8371C7.58057 12.3532 8.41943 12.3532 8.93932 11.8371L11.6296 9.16667L12.3333 9.86524L8 14.1667Z'
      fill='currentColor'
    />
  </Icon16>
)

export const CheckIcon = (props: IconProps) => (
  <Icon16 {...props}>
    <path
      d='M13.701 4.33335L5.67281 12.3333L1.83203 8.50558L2.53672 7.80328L4.7316 9.99072C5.25193 10.5093 6.09368 10.5093 6.61401 9.99072L12.9963 3.63105L13.701 4.33335Z'
      fill='currentColor'
    />
  </Icon16>
)

export const CloseSmallIcon = (props: IconProps) => (
  <Icon16 {...props}>
    <path d='m4 4 8 8M12 4l-8 8' {...stroke(1.5)} />
  </Icon16>
)

export const ClearCircleIcon = (props: IconProps) => (
  <svg viewBox='0 0 16 16' aria-hidden='true' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM5.47 5.47a.75.75 0 0 1 1.06 0L8 6.94l1.47-1.47a.75.75 0 1 1 1.06 1.06L9.06 8l1.47 1.47a.75.75 0 1 1-1.06 1.06L8 9.06l-1.47 1.47a.75.75 0 0 1-1.06-1.06L6.94 8 5.47 6.53a.75.75 0 0 1 0-1.06Z'
    />
  </svg>
)
